var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"flex flex-wrap"},[_c('div',{staticClass:"px-4 w-full"},[_c('BigTitle',{staticClass:"mb-11 pt-40",attrs:{"title":"Settings"}}),_c('BillingPlans')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }